// utils/storage.ts
import AsyncStorage from "@react-native-async-storage/async-storage";

const TOKEN_KEY = "user_token";
const USER_KEY = "user_data";

export const storage = {
  setToken: async (token: string) => {
    await AsyncStorage.setItem(TOKEN_KEY, token);
  },
  getToken: async () => {
    return await AsyncStorage.getItem(TOKEN_KEY);
  },
  removeToken: async () => {
    await AsyncStorage.removeItem(TOKEN_KEY);
  },
  setUser: async (user: any) => {
    await AsyncStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  getUser: async () => {
    const data = await AsyncStorage.getItem(USER_KEY);
    return data ? JSON.parse(data) : null;
  },
  removeUser: async () => {
    await AsyncStorage.removeItem(USER_KEY);
  },
  clearAuth: async () => {
    await AsyncStorage.multiRemove([TOKEN_KEY, USER_KEY]);
  },
};
